import MessageTemplateDialog from './MessageTemplateDialog';

export { MessageTemplateDialog };
export default MessageTemplateDialog;
